import styled from 'styled-components';
import { Row as RowGrid, Col as ColGrid } from 'react-grid-system';

export const Row = styled(RowGrid)`
  margin-bottom: ${(props) =>
    props.bottomMargin ? props.bottomMargin : '30px'};
`;
export const Col = styled(ColGrid)`
  min-height: ${({ $minHeight }) => $minHeight || 'unset'};
  margin-bottom: ${({ $marginBottom }) => $marginBottom || 'unset'};
`;

export const StyledCol = styled(Col)`
  padding: ${(props) => (props.padding ? props.padding : '10px')};
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'unset')};
`;
